const form = document.getElementById("search-kit");
var metafieldsArray = [];
var kitProducts = {};
var bundleProducts = {};
var kits = {};
var discount = [];
var renderSezzle = [];
if (collectionKits.length > 0) {
  defaultKits();

  //render sezzle widget by kit
  Object.entries(renderSezzle).forEach((a) => {
    a[1].init();
  });
}
document.getElementById("reset-form").addEventListener("click", function (e) {
  document.querySelector(".loading-img").style.display = "block";
  var $wrapperGrid = document.querySelector(".kits-wrapper");
  while ($wrapperGrid.firstChild) {
    $wrapperGrid.removeChild($wrapperGrid.firstChild);
  }
  document.getElementById("search-kit").reset();
  bundleProducts = {};
  defaultKits();
});
function defaultKits() {
  document.querySelector(".kits-wrapper").style.display = "none";
  document.querySelector(".loading-img").style.display = "block";

  for (let c of collectionKits) {
    if (c == "") return;
    var $wrapper = document.querySelector(".kits-wrapper");
    renderSezzle[c] = new AwesomeSezzle({
      amount: "0",
      renderElement: "sezzle-widget-" + c,
    });
    skeletonKits($wrapper, c);

    getRelatedProductByKitSelected(c);
  }
}
var kitDescription = "";
const queryKits = async () => {
  document.querySelector(".loading-img").style.display = "block";
  document.querySelector(".kits-wrapper").style.display = "none";

  var myHeaders = new Headers();

  myHeaders.append("Access-Control-Allow-Origin", "*");

  myHeaders.append("Content-Type", "application/json");

  var graphql = JSON.stringify({
    url: "/admin/api/2023-04/graphql.json",
    payload: {
      query:
        '{ products(first: 50, query:"product_type:\'Kit\'") { pageInfo { hasNextPage } edges { cursor node { legacyResourceId title gender: metafield( namespace: "custom" key: "gender" ) { value } weight: metafield( namespace: "custom" key: "weight" ) { value } size: metafield( namespace: "custom" key: "size" ) { value } height: metafield( namespace: "custom" key: "height" ) { value } } } }}',
      variables: {},
    },
  });
  var requestOptions = {
    method: "POST",
    body: graphql,
    redirect: "follow",
  };

  const promise = await fetch(
    "https://zqvs7qgrmi.execute-api.us-east-1.amazonaws.com/kings_shopify",
    requestOptions
  );

  const response = await promise.json();
  getMetafields(response.data.products.edges);
};

queryKits();

function searchKit(e) {
  if (!/^(male|female|unisex)$/.test(e.target.elements[0].value)) {
    e.target.elements[0].style.border = "1px solid red";
    return false;
  }
  e.preventDefault();
  const entries = {
    gender: e.target.elements[0].value,
    size: Number(e.target.elements[1].value),
    height: Number(e.target.elements[2].value),
    weight: Number(e.target.elements[3].value),
  };
  document.querySelector(".loading-img").style.display = "block";
  matchingKit(entries);
}

function getMetafields(metafields) {
  metafields.forEach((element) => {
    let product = {};
    product.gender = element.node.gender.value;
    product.size = JSON.parse(element.node.size.value);
    product.product_id = element.node.legacyResourceId;
    product.height = JSON.parse(element.node.height.value);
    product.weight = JSON.parse(element.node.weight.value);
    product.kit_name = element.node.title;
    metafieldsArray.push(product);
  });
}
/**
 * get metafields product by kit
 * @param {*} kit_id
 */
function getRelatedProductByKitSelected(kit_id) {
  var graphql = JSON.stringify({
    url: "/admin/api/2023-04/graphql.json",
    payload: {
      query:
        "query GetProductsById($id: ID!) {  product(id: $id) {    title images(first: 1) { edges { node { originalSrc }}} description  metafields:  metafields(first: 200) {                    edges {                        node {                            namespace                            key                            value                        }                    }                }                    }  }",
      variables: { id: `gid://shopify/Product/${kit_id}` },
    },
  });
  var requestOptions = {
    method: "POST",
    body: graphql,
    redirect: "follow",
  };

  fetch(
    "https://zqvs7qgrmi.execute-api.us-east-1.amazonaws.com/kings_shopify",
    requestOptions
  )
    .then((response) => response.json())
    .then((result) => {
      // let productIds = JSON.parse(
      //   result.data.product.metafields.edges[0].node.value
      // );

      var bundlesKitProductsIds = {};
      var bundlesKitProductsIdsGid = {};
      result.data.product.metafields.edges.forEach((item) => {
        if (item.node.key.indexOf("bundle_") !== -1) {
          bundlesKitProductsIds[item.node.key] = JSON.parse(
            item.node.value
          ).map((i) => i.replace("gid://shopify/Product/", ""));
          bundlesKitProductsIdsGid[item.node.key] = JSON.parse(item.node.value);
        }
      });

      const degrees = result.data.product.metafields.edges.find(
        (m) => m.node.key == "weather"
      );
      const bannerKitTitle = result.data.product.metafields.edges.find(
        (m) => m.node.key == "banner_kit_title"
      );
      const degreesDescription = result.data.product.metafields.edges.find(
        (m) => m.node.key == "degree_description"
      );

      let kit = {};
      kit[kit_id] = {
        name: result.data.product.title,
        description: result.data.product.description,
      };
      if (result.data.product.images.edges.length > 0) {
        var $w = document.querySelector(`.kit-${kit_id}`);
        const template = `
        <div class="content-text" style="background-image:url('https://${assetUrl}/bg_kits_text.png')">
        <h2>${bannerKitTitle && bannerKitTitle.node.value}</h2>
        ${degrees && "<h3>" + degrees.node.value + "</h3>"}
        ${degreesDescription && "<p>" + degreesDescription.node.value + "</p>"}
        </div>
        <img class="kit-image" src=""/>
        `;
        $w.querySelector(".banner-image").innerHTML = template;
        $w.querySelector(".kit-image").src =
          result.data.product.images.edges[0].node.originalSrc;
      }
      kits = { ...kits, ...kit };

      //deprecated
      // let ids = productIds.map((id) => {
      //   return id.replace("gid://shopify/Product/", "");
      // });

      getInfoProducts(bundlesKitProductsIdsGid, bundlesKitProductsIds, kit_id);
    })
    .catch((error) => console.log("error", error));
}

async function matchingKit(entries) {
  var $wrapper = document.querySelector(".kits-wrapper");
  bundleProducts = {};
  metafieldsArray.forEach(async (item) => {
    let matchingLevel = 0;
    if (item.gender.toLowerCase() == entries.gender.toLowerCase()) {
      ++matchingLevel;
    }
    if (
      item.size[0].value <= entries.size &&
      item.size[1].value >= entries.size
    ) {
      ++matchingLevel;
    }
    if (
      item.height[0].value <= entries.height &&
      item.height[1].value >= entries.height
    ) {
      ++matchingLevel;
    }
    if (
      item.weight[0].value <= entries.weight &&
      item.weight[1].value >= entries.weight
    ) {
      ++matchingLevel;
    }
    item.matchingLevel = matchingLevel;
  });

  var $wrapperGrid = document.querySelector(".kits-wrapper");
  while ($wrapperGrid.firstChild) {
    $wrapperGrid.removeChild($wrapperGrid.firstChild);
  }

  kits = {};
  metafieldsArray.forEach((m) => {
    skeletonKits($wrapper, m.product_id);
  });
  metafieldsArray.sort((a, b) => (a.matchingLevel <= b.matchingLevel ? 1 : -1));
  metafieldsArray.forEach((metafield, index) => {
    if (index <= 2) getRelatedProductByKitSelected(metafield.product_id);
  });
}
form.onsubmit = searchKit;

function getInfoProducts(
  bundlesKitProductsIdsGid,
  bundlesKitProductsIds,
  kit_id
) {
  let ids = [];
  let idsGid = [];
  Object.entries(bundlesKitProductsIds).forEach((a) => {
    ids = [...ids, ...a[1]];
  });
  Object.entries(bundlesKitProductsIdsGid).forEach((a) => {
    idsGid = [...idsGid, ...a[1]];
  });

  var requestOptions = {
    method: "POST",
    body: JSON.stringify({
      url: "/admin/api/2023-04/products.json?ids=" + ids.join(","),
    }),
    redirect: "follow",
  };

  fetch(
    "https://zqvs7qgrmi.execute-api.us-east-1.amazonaws.com/kings_shopify",
    requestOptions
  )
    .then((response) => response.json())
    .then(async (result) => {
      result.products = result.products.sort((a, b) => {
        const indexA = ids.findIndex((i) => i == a.id);
        const indexB = ids.findIndex((i) => i == b.id);

        // Si ambos elementos están en el array de referencia, los ordenamos según su posición en el mismo.
        if (indexA !== -1 && indexB !== -1) {
          return indexA - indexB;
        }

        // Si solo uno de los elementos está en el array de referencia, se coloca primero.
        if (indexA !== -1) {
          return -1;
        }

        if (indexB !== -1) {
          return 1;
        }

        // Si ninguno de los elementos está en el array de referencia, se mantiene el orden original.
        return 0;
      });
      const metafields = await getAllMetafieldsByArrayIds(idsGid);

      let productByKit = {};

      productByKit[kit_id] = result.products.map((product) => {
        const metafieldsExists = metafields.data.nodes.find(
          (metafields) => metafields.id == product.admin_graphql_api_id
        );
        if (metafieldsExists) {
          product["metafields"] = metafieldsExists;
          //
        }
        for (let bundleName of Object.entries(bundlesKitProductsIdsGid)) {
          const exists = bundlesKitProductsIdsGid[bundleName[0]].find((id) => {
            return product.admin_graphql_api_id == id;
          });
          if (exists) {
            if (!bundleProducts[kit_id]) bundleProducts[kit_id] = {};
            if (!bundleProducts[kit_id][bundleName[0]])
              bundleProducts[kit_id][bundleName[0]] = [];

            bundleProducts[kit_id][bundleName[0]].push(product);
          }
        }
        return product;
      });

      kitProducts = {
        ...kitProducts,
        ...productByKit,
      };

      makeGrid(kit_id);
    })
    .catch((error) => console.log("error", error));
}
async function getAllMetafieldsByArrayIds(productIds) {
  var graphql = JSON.stringify({
    url: "/admin/api/2023-04/graphql.json",
    payload: {
      query:
        '\n\n     query getProductsByIdArray($ids : [ID!]!) { nodes(ids: $ids) {   \n          ... on Product {  id\n                title\n                l_tag: metafield(\n                    namespace:"custom"\n                    key: "l_tag"\n                ) {\n                    value\n                }\n                logo: metafield(\n                    namespace:"custom"\n                    key: "logo"\n                ) {\n                    value\n                }               \n            }\n        }\n    }\n',
      variables: { ids: productIds },
    },
  });
  var requestOptions = {
    method: "POST",
    body: graphql,
    redirect: "follow",
  };

  const promise = await fetch(
    "https://zqvs7qgrmi.execute-api.us-east-1.amazonaws.com/kings_shopify",
    requestOptions
  );
  return await promise.json();
}
function variantsPosition(options) {
  const colorOption = options.find((option) => option.name == "Color");
  const sizeOption = options.find((option) => option.name == "Size");
  return {
    color: colorOption ? "option" + colorOption.position : 0,
    size: sizeOption ? "option" + sizeOption.position : 0,
  };
}
function makeGrid(kit_id) {
  let $grid = document.querySelector(".kit-" + kit_id + " .items-grid");

  while ($grid.firstChild) {
    $grid.removeChild($grid.firstChild);
  }

  let someProductWithVariants = false;
  // const bundlePart = product.metafields.metafields.edges.find(metafield => metafield.node.key == 'bundle-part')
  if (!bundleProducts[kit_id]) return;
  Object.keys(bundleProducts[kit_id]).forEach((bund, index) => {
    let product = bundleProducts[kit_id][bund][0];
    let item = document.createElement("div");
    item.className = "item-grid grid-product";
    item.setAttribute("data-product-id", product.id);
    item.setAttribute("data-kit-id", kit_id);
    item.setAttribute("data-bundle", bund);
    item.setAttribute("data-product-handle", product.handle);

    const options = variantsPosition(product.options);

    let groupByColors = [];

    if (options.color !== 0 && options.size !== 0) {
      groupByColors = product.variants.reduce(function (rv, x) {
        (rv[x[options.color]] = rv[x[options.color]] || []).push(x);
        return rv;
      }, {});

      someProductWithVariants = true;
    } else {
      return false;
    }

    item.innerHTML = makeTemplate(
      product,
      groupByColors,
      options,
      bund,
      kit_id
    );
    $grid.append(item);
  });
  if (someProductWithVariants) {
    $grid.parentElement.style.display = "flex";
    $grid.parentElement.querySelector(".sidebar h2").innerText =
      kits[kit_id].name;
    $grid.parentElement.querySelector(".sidebar p").innerText =
      kits[kit_id].description;
    $grid.parentElement.querySelector("#no-items").style.display = "none";
  } else {
    $grid.parentElement.querySelector("#no-items").style.display = "block";
    $grid.parentElement.style.display = "none";
  }
  changeTotalPrice(kit_id);
  reviewOutStockSelected();
  document.querySelector(".kits-wrapper").style.display = "block";
  document.querySelector(".loading-img").style.display = "none";

  theme.initQuickShop();
}
function makeTemplate(product, groupByColors, options, b, kit_id) {
  return `
                    <div class="image-container">
                    <div class="quick-product__btn fix-btn-quick quick-product__btn--not-ready js-modal-open-quick-modal-${
                      product.id
                    } medium-down--hide">
                    <span class="quick-product__label">QuickVIew</span></div>
                    <div class="tags">
                    ${
                      product.metafields.logo
                        ? `<img src="https://${assetUrl}/${product.metafields.logo?.value}.svg">`
                        : ""
                    }
  ${
    product.metafields.l_tag
      ? `<img src="https://${assetUrl}/${product.metafields.l_tag.value}.svg" class="l-tag">`
      : ""
  }
                    </div>
                    <img class="product-image" onclick="window.location.href= '/products/${
                      product.handle
                    }'" src=${
    product.images.find((i) => i.id == product.variants[0].image_id).src
  }>
                    </div>
                    <div class="" style="text-align:left">
                    <div class="grid-product__title t_clickable" onclick="window.location.href= '/products/${
                      product.handle
                    }'">
                    ${
                      product.tags
                        .split(",")
                        .find((tag) => tag.indexOf("_label_") > -1)
                        ? `<span class="on-sale-box custom-label--added">${String(
                            product.tags
                              .split(",")
                              .find((tag) => tag.indexOf("_label_") > -1)
                          ).replace("_label_", "")}</span>`
                        : ""
                    }
                    ${
                      product.variants[0].compare_at_price >
                      product.variants[0].price
                        ? '<span class="on-sale-box">SALE</span>&nbsp;'
                        : ""
                    }
                    <span style="display:inline-block;margin-bottom:3px">${
                      product.title
                    }</span>
                    </div>
                    
                    <div class="price grid-product__price">
                    ${
                      product.variants[0].compare_at_price >
                      product.variants[0].price
                        ? '<span class="grid-product__price--original">$' +
                          product.variants[0].compare_at_price +
                          "</span>"
                        : ""
                    }
                    <span class="price_value">$${product.variants[0].price} </span>
                    </div>
                    
                    </div>
                    <div>
                    <div class="qty-sizes-container">
                    <div class="qty">
                        <div class="label-kit">Quantity</div>
                        <select onchange="selectQty(this)" class="qty select" product-id="${
                          product.id
                        }" id="${product.id}">
                        ${qtyoptions()}
                        </select>
                    </div>
                  <div class="sizes">
                    <div class="label-kit">Size</div>
                        ${Object.keys(groupByColors)
                          .map((keyColor, index) => {
                            return `<select onchange="selectSize(this)"  class="size ${
                              index == 0 ? "active" : ""
                            }" data-color="${keyColor.replaceAll(
                              " ",
                              "-"
                            )}">${groupByColors[keyColor].map((size) => {
                              if (size.inventory_quantity > 0)
                                return `<option value="${
                                  size.id
                                }" product-id="${product.id}">${
                                  size[options.size]
                                }</option>`;
                            })}</select>`;
                          })
                          .join("")}
                    </div>
                  </div>
                    <div class="colors-container">
                    <div class="label-kit">Color: <span style="font-weight:500">${Object.keys(
                      groupByColors
                    )[0].replaceAll(" ", "-")}</span></div>
                    <div class="colors">
                        ${Object.keys(groupByColors)
                          .map((key, index) => {
                            const quantity = groupByColors[key].map(
                              (item) => item.inventory_quantity
                            );
                            return (
                              '<div class="color ' +
                              (index == 0 ? "active" : "") +
                              (quantity.reduce((a, b) => a + b) <= 0
                                ? " out-stock"
                                : "") +
                              '" data-color="' +
                              key.replaceAll(" ", "-") +
                              `" ${
                                quantity.reduce((a, b) => a + b) > 0
                                  ? 'onclick="changeColor(event)"'
                                  : ""
                              } style="background-image:url(https:${colorPath}/${key
                                .replaceAll(" ", "-")
                                .toLowerCase()}.png);background-color:${key};"> 
                              ${
                                quantity.reduce((a, b) => a + b) <= 0
                                  ? '<div class="out-stock-line"></div>'
                                  : ""
                              }</div>`
                            );
                          })
                          .join("")}
                    </div>
                    </div>
                  
                    <a class="replace-button" onclick="replaceFc(event,${
                      product.id
                    },'${b}',${kit_id})">Other options <img src="https://${assetUrl}/replace.svg"></a>
                    <label class="replace-text">Don't need this garment?</label>
                    <a class="remove-button"onclick="removeItem(event,${
                      product.id
                    },${kit_id})">Remove it</a>
                    ${quickviewTemplate(product)}
                    
                    `;
}
function quickviewTemplate(product) {
  return ` <div id="QuickShopModal-${product.id}" class="modal modal--square modal--quick-shop" data-product-id="${product.id}">
  <div class="modal__inner">
    <div class="modal__centered">
      <div class="modal__centered-content">
        <div id="QuickShopHolder-${product.handle}"></div>
      </div>
      <button type="button" class="modal__close js-modal-close text-link">
        <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64"><path d="M19 17.61l27.12 27.13m0-27.12L19 44.74"/></svg>
        <span class="icon__fallback-text">{{ 'general.accessibility.close_modal' | t | json }}</span>
      </button>
    </div>
  </div>
</div>`;
}
function removeItem(event, productId, kit_id) {
  event.preventDefault();

  // document.querySelector('.item-grid[data-product-id="'+productId+'"]').remove();
  let item = document.querySelector(
    ".kit-" + kit_id + ' .item-grid[data-product-id="' + productId + '"]'
  );
  document
    .querySelector(
      ".kit-" + kit_id + ' .item-grid[data-product-id="' + productId + '"]'
    )
    .classList.add("removed");
  let addLayer = document.createElement("div");
  addLayer.className = "overlay";
  addLayer.innerHTML = `<button class="add-it-back" onclick="undo(this)">Add it back</button>`;
  document
    .querySelector(
      ".kit-" + kit_id + ' .item-grid[data-product-id="' + productId + '"]'
    )
    .prepend(addLayer);
  changeTotalPrice(item.getAttribute("data-kit-id"));
}
function undo(target) {
  target.parentNode.parentNode.classList.remove("removed");
  changeTotalPrice(target.parentNode.parentNode.getAttribute("data-kit-id"));
  target.parentNode.remove();
}
function selectSize(target) {
  const optionSelected = target.options[target.selectedIndex];
  const variantId = optionSelected.value;
  const productID = optionSelected.getAttribute("product-id");

  const $product = document.querySelector(
    '.item-grid[data-product-id="' + productID + '"]'
  );
  replacePriceImage($product, productID, variantId);
  changeTotalPrice($product.getAttribute("data-kit-id"));
}
function selectQty(target) {
  const optionSelected = target.options[target.selectedIndex];
  const variantId = optionSelected.value;
  const productID = target.getAttribute("product-id");

  const $product = document.querySelector(
    '.item-grid[data-product-id="' + productID + '"]'
  );
  changeTotalPrice($product.getAttribute("data-kit-id"));
}
function changeColor(event) {
 
  $lastActive = event.target.parentNode.querySelector(".active");
  const color = event.target.getAttribute("data-color");
  if ($lastActive) $lastActive.classList.remove("active");
  event.target.classList.add("active");

  const $ProductItem =
    event.target.parentNode.parentNode.parentNode.parentNode;
    
  $sizes = $ProductItem.querySelector(".sizes");

  const prevSize = $sizes.querySelector(".active");
  let prevSizeName = "";
  if (prevSize && prevSize.selectedIndex > -1) {
    prevSizeName =
      $sizes.querySelector(".active").options[prevSize.selectedIndex].text;
  }
  $sizes.querySelector(".active").classList.remove("active");
  
  $currentSizes = $sizes.querySelector(`.size[data-color=${color}`);

  $currentSizes.classList.add("active");
  $sizeExist = Array.from($currentSizes.options).find(
    (option) => option.text == prevSizeName
  );

  $ProductItem.querySelector(".label-kit span").innerText = color.replaceAll(
    "-",
    " "
  );

  let variantId = 0;
  if ($sizeExist) {
    variantId = $sizeExist.value;
    $currentSizes.value = variantId;
  } else {
    variantId = $currentSizes.value;
  }
  
  if (kitProducts[$ProductItem.getAttribute("data-kit-id")]) {
    const product = kitProducts[$ProductItem.getAttribute("data-kit-id")].find(
      (product) => product.id == $ProductItem.getAttribute("data-product-id")
    );
    
    replacePriceImage($ProductItem, product.id, variantId);
    changeTotalPrice($ProductItem.getAttribute("data-kit-id"));
  }

  //qtyoptionDynamically($ProductItem, product.id, variantId);
}
function replacePriceImage($productElement, productId, variantId) {
  const product = kitProducts[$productElement.getAttribute("data-kit-id")].find(
    (product) => product.id == productId
  );
  const variant = product.variants.find((variant) => variant.id == variantId);

  if (variant.compare_at_price > variant.price) {
    $productElement.querySelector(
      ".price .grid-product__price--original"
    ).innerText = "$" + variant.compare_at_price;
  } else
    $productElement.querySelector(".price .price_value").innerText = "$" + variant.price;

  $productElement
    .querySelector(".product-image")
    .setAttribute(
      "src",
      product.images.find((image) => image.id == variant.image_id).src
    );
}
function changeTotalPrice(kit_id) {
  let total = 0.0;
  var $kit = document.querySelector(".kit-" + kit_id);
  $kit.querySelectorAll(".item-grid").forEach((item) => {
    try{
      var price = item.querySelector(".price .price_value");
      var qty = item.querySelector(".qty.select").value;
      if (!item.classList.contains("removed"))
        total += Number(price.innerText.replace("$", "")) * Number(qty);
    }
    catch(error){
      console.log(`%c item`,'color: white;background: #006bb4;padding: 5px 5px 5px 0px;font-weight: 1000;',item);
      console.error("kit --->",kit_id);
    }
  });

  if (total.toFixed(2) == 0) $kit.querySelector(".btn-add-kit").disabled = true;
  else $kit.querySelector(".btn-add-kit").disabled = false;

  discount = discount.sort((a, b) => a.purchase < b.purchase);

  let arrayAmountDiscount = [];
  for (let d of discount) {
    if (d.purchase < total) {
      arrayAmountDiscount.push(total * d.discountPercentage);
      apply = true;
    }
  }
  
  if (arrayAmountDiscount.length == 0) {
    $kit.querySelector("#discount-kit").innerText = "";
    $kit.querySelector("#total-price-kit").innerText = `$${total.toFixed(2)}`;
    renderSezzle[kit_id].alterPrice(total.toFixed(2));
  } else {
    
    $kit.querySelector("#discount-kit").innerText = `Save $${Math.max(
      ...arrayAmountDiscount
    ).toFixed(2)}`;
    $kit.querySelector("#total-price-kit").innerText = `$${(
      total - Math.max(...arrayAmountDiscount)
    ).toFixed(2)}`;
    renderSezzle[kit_id].alterPrice(
      (total - Math.max(...arrayAmountDiscount)).toFixed(2)
    );
  }
}
function makeReplacePopup(kit_id) {
  let bodyPopup = document.createElement("div");
  bodyPopup.className = "popup-body";

  const template = `
  <div class="close-pp" onclick="closePP()">
  <svg xmlns="http://www.w3.org/2000/svg" width="25.414" height="25.414" viewBox="0 0 25.414 25.414">
  <g id="Group_32930" data-name="Group 32930" transform="translate(0.707 0.707)">
    <line id="Line_56" data-name="Line 56" x1="24" y2="24" fill="none" stroke="#475b58" stroke-width="2"/>
    <line id="Line_57" data-name="Line 57" x2="24" y2="24" fill="none" stroke="#475b58" stroke-width="2"/>
  </g>
</svg>

  </div>
  <div class="info-selection">
  <div class="current">Current Selection</div>
  <div class="other-options">Other Options</div>
  </div>
  
  ${Object.keys(bundleProducts[kit_id])
    .map((b) => {
      return `<div data-bundle="${b}" class="bundles products">
      ${bundleProducts[kit_id][b]
        .map((product, index) =>
          makePopupItemTemplate(product, b, index, kit_id)
        )
        .join("")}</div>`;
    })
    .join("")}
   
  `;
  bodyPopup.innerHTML = template;
  document.querySelector(".popup-replace-bundle").append(bodyPopup);
}
function skeletonKits($wrapper, productId) {
  var newKitDom = document.createElement("div");
  newKitDom.classList = `container-kit kit-${productId}`;
  var templateKit = `
      <div class="banner-image"  style="background-image:url('https://${assetUrl}/bg-kits-image_2.png'); background-size:cover"></div>
      <div class="sidebar">
        <h2></h2>
        <p></p>
        <div class="price">
          <div id="total-price-kit"></div>
          <span id="discount-kit"></span>
        </div>
    
        <button onclick="addToCart(${productId});" class="btn-default btn-add-kit ${
    isMaciPhoneOriPad() === true ? "" : "patch-win"
  }">ADD KIT TO CART</button>
        <div id="sezzle-widget-${productId}"></div>
      </div>
  
      <div class="items-grid products"></div>
    </div>
    <div id="no-items" style="display:none">
    <br>
    <br>
    <br>
    <br>
    <label>No Items</label>
    </div>
    `;

  newKitDom.innerHTML = templateKit;
  $wrapper.appendChild(newKitDom);
}
function makePopupItemTemplate(product, bundleType, index, kit_id) {
  return `<div class="bundle-item" data-product-id="${
    product.id
  }" onclick="replaceProduct(${index},'${bundleType}',${kit_id})" >
       
  <div class="image-container">
  <div class="tags">
  ${
    product.metafields.logo
      ? `<img src="https://${assetUrl}/${product.metafields.logo.value}.svg">`
      : ""
  }
  ${
    product.metafields.l_tag
      ? `<img src="https://${assetUrl}/${product.metafields.l_tag.value}.svg" class="l-tag">`
      : ""
  }
          
        </div>
    <img class="product-image" src=${product.image.src}>
  </div>
  <div class="grid-product__title">${product.title}</div>
  <div class="price grid-product__price">$${product.variants[0].price}</div>

  <button class="btn-default ${
    isMaciPhoneOriPad() === true ? "" : "patch-win"
  }" onclick="replaceProduct(${index},'${bundleType}',${kit_id})" data-product-id="${
    product.id
  }"> select</button>
  
</div>`;
}
function closePP() {
  document.querySelector(".popup-replace-bundle").style.display = "none";
  document.querySelector("body").style.overflow = "auto";
}
function replaceProduct(index, bundlePart, kit_id) {
  let product = bundleProducts[kit_id][bundlePart][index];
  let item = document.querySelector(
    ".kit-" + kit_id + ' .item-grid[data-bundle="' + bundlePart + '"]'
  );
  item.setAttribute("data-product-id", product.id);
  item.setAttribute("data-kit-id", kit_id);
  item.setAttribute("data-product-handle", product.handle);

  const options = variantsPosition(product.options);

  let groupByColors = [];

  if (options.color !== 0 && options.size !== 0) {
    groupByColors = product.variants.reduce(function (rv, x) {
      (rv[x[options.color]] = rv[x[options.color]] || []).push(x);
      return rv;
    }, {});
    someProductWithVariants = true;
  } else {
    return false;
  }

  item.innerHTML = makeTemplate(
    product,
    groupByColors,
    options,
    bundlePart,
    kit_id
  );

  document
    .querySelectorAll(".popup-replace-bundle .bundles.active [data-product-id]")
    .forEach((bundle) => {
      bundle.style.display = "block";
    });
  changeTotalPrice(kit_id);
  document.querySelector(".popup-replace-bundle").style.display = "none";
  document.querySelector("body").style.overflow = "auto";
  theme.replacedItemQuickShop(product.id, product.handle);
}
function replaceFc(event, product_id, bundleName, kit_id) {
  if (document.querySelector(".popup-body"))
    document.querySelector(".popup-body").remove();
  makeReplacePopup(kit_id);
  let bundles = document.querySelectorAll(".popup-replace-bundle .bundles");

  const other = document.createElement("div");
  other.innerText = "Other Option";
  other.className = "other-option-mobile";
  bundles.forEach((bundle) => {
    if (window.innerWidth < 912) {
      bundle.style.gridTemplateRows = `repeat(${
        bundle.children.length == 1
          ? bundle.children.length + 1
          : bundle.children.length
      },1fr)`;
    } else
      bundle.style.gridTemplateColumns = `repeat(${
        bundle.children.length == 1
          ? bundle.children.length + 1
          : bundle.children.length
      },1fr)`;

    if (bundle.getAttribute("data-bundle") !== bundleName)
      bundle.classList.remove("active");
    else {
      bundle.classList.add("active");
      bundle.querySelector(".image-container");
      bundle.querySelector(
        'button[data-product-id="' + product_id + '"]'
      ).style.display = "none";
      bundle.querySelector(
        '.bundle-item[data-product-id="' + product_id + '"]'
      ).style.gridArea = "1/1";
      // bundle.querySelector(
      //   '.bundle-item[data-product-id="' + product_id + '"] .image-container'
      // ).style.border = "4px solid #BFC78C";
      bundle
        .querySelector('.bundle-item[data-product-id="' + product_id + '"]')
        .appendChild(other);
    }
  });
  document.querySelector(".popup-replace-bundle").style.display = "flex";
  document.querySelector("body").style.overflow = "hidden";
}
function getDiscount() {
  if (discountId == "") return;

  let ids = discountId.split(",");
  for (let id of ids) {
    var graphql = JSON.stringify({
      url: "/admin/api/2023-04/graphql.json",
      payload: {
        query:
          '{\n  automaticDiscountNode(\n    id: "gid://shopify/DiscountAutomaticNode/' +
          id +
          '"\n  ) {\n    ... on DiscountAutomaticNode {\n      id\n    }\n    automaticDiscount {\n      ... on DiscountAutomaticBasic {\n        title\n        summary\n        status\n\n      shortSummary  customerGets {\n          items {\n            ... on AllDiscountItems {\n              allItems\n            }\n          }\n        }\n      }\n    }\n  }\n}\n',
        variables: {},
      },
    });
    var requestOptions = {
      method: "POST",
      body: graphql,
      redirect: "follow",
    };

    fetch(
      "https://zqvs7qgrmi.execute-api.us-east-1.amazonaws.com/kings_shopify",
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        const summary =
          result.data?.automaticDiscountNode?.automaticDiscount?.summary;
        const minimum = summary
          .substring(summary.length - 1, summary.indexOf("$") + 1)
          .replace("%", "");
        discountPercentage = summary.substring(0, summary.indexOf("off"));
        discountPercentage = Number(discountPercentage.replace("%", "")) / 100;
        let d = {
          purchase: Number(minimum),
          discountPercentage: discountPercentage,
        };
        discount.push(d);
      })
      .catch((error) => console.log("error", error));
  }
}
function reviewOutStockSelected() {
  
  document.querySelectorAll(".color.active.out-stock").forEach((element) => {
    let exist = false;
    Array.from(element.parentElement.children).forEach((i) => {
      if (exist) return;

      if (i.classList.value.indexOf("out-stock") == -1) {
        i.click();
        exist = true;
      }
    });
    
    if(exist == false){
      element.closest('.item-grid').remove();      
    }
  });
}

getDiscount();
// add kit
function addToCart(kit) {
  let items = [];
  document
    .querySelectorAll(".kit-" + kit + " .items-grid .item-grid")
    .forEach((cardProduct) => {
      if (cardProduct.classList.contains("removed")) return;
      let item = {
        id: cardProduct.querySelector(".size.active").value,
        quantity: cardProduct.querySelector(".qty.select").value,
      };

      items.push(item);
    });
    debugger
  let myHeaders = new Headers();
  myHeaders.append(
    "X-Shopify-Storefront-Access-Token",
    "142f1ca8bb7165722781f903f47e368d"
  );
  myHeaders.append("Content-Type", "application/json");
  fetch("/cart/add.js", {
    headers: {
      "Content-Type": "application/json",
    },
    method: "POST",
    body: JSON.stringify({ items: items }),
  })
    .then((r) => r.json())
    .then((response) => {
      //window.location.href = "/cart";
    });
}
function qtyoptions() {
  let options;
  for (let i = 1; i <= 15; i++) {
    options += `<option value="${i}" >${i}</option>`;
  }
  return options;
}
function qtyoptionDynamically($productElement, productId, variantId) {
  const product = kitProducts[$productElement.getAttribute("data-kit-id")].find(
    (product) => product.id == productId
  );
  const variant = product.variants.find((variant) => variant.id == variantId);

  console.log(variant.inventory_quantity);
}
document
  .querySelector(".popup-replace-bundle")
  .addEventListener("click", function () {
    closePP();
  });
// form
document
  .querySelector(".control-gender input")
  .addEventListener("focus", () => {
    document.querySelector(".gender-values").style.display = "inline";
  });
document.querySelector(".control-gender input").addEventListener("blur", () => {
  setTimeout(
    () => (document.querySelector(".gender-values").style.display = "none"),
    300
  );
});
document.querySelectorAll(".gender-values .item").forEach((item) => {
  item.addEventListener("click", (e) => {
    const value = e.target.getAttribute("data-value");
    document.querySelector(".control-gender input").value = value;
    document.querySelector(".gender-values").style.display = "none";
  });
});
